export default __webpack_public_path__ + "static/media/Sebastian128x128.35672e7b.jpg";